
import { Drawer } from '@/components';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { cx } from '@emotion/css';
import styles from "./LoginDrawer.styles";
import { Login } from '../Login/Login';
import MagicLinkSuccess from '../MagicLinkSuccess/MagicLinkSuccess'
import { useReactiveVar } from '@apollo/client';
import { openLoginDrawerVar, showMagicLinkSuccessVar, loginEmailVar } from '@/graphql/state';
import { Box } from '@mui/system';
import { ButtonFlatMedium } from '@/design-system';
import { useEffect } from 'react';
import { useLogin } from '@/hooks/useLogin';
import { useSnackbar } from '@/design-system';

export const LoginDrawer: React.FC = () => {
  const openLoginDrawer = useReactiveVar(openLoginDrawerVar);
  const showMagicLinkSuccess = useReactiveVar(showMagicLinkSuccessVar);
  const loginEmail = useReactiveVar(loginEmailVar);
  const { requestMagicLink } = useLogin();
  const showToast = useSnackbar();

  useEffect(() => {
    showMagicLinkSuccessVar(false)
  }, [])

  const handleToggleDrawer = (open: boolean) => (event: any) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    onDismiss();
  };

  const resendLink = async () => {
    showToast('Your email is on its way.');
    const magicLinkGenerated = await requestMagicLink(loginEmail.toString())
    if (magicLinkGenerated) {
      showToast('Your email is on its way.');
      return;
    }
    showToast(
      'Unfortunately, something went wrong and we were unable to send the email. Please try again.',
    );
  };

  const onDismiss = () => {
    openLoginDrawerVar(false);
  }

  const updateEmail = () => {
    showMagicLinkSuccessVar(false)
  };

  return (
    <SwipeableDrawer
      className={cx(styles.container)}
      anchor="bottom"
      open={openLoginDrawer}
      onClose={handleToggleDrawer(false)}
      onOpen={handleToggleDrawer(true)}
      disableSwipeToOpen
      data-testid="optionsContainer"
    >
      <Box sx={{ width: 'auto' }} className={styles.cancelButtonContainer}>
        <ButtonFlatMedium onClick={onDismiss}>
          Cancel
        </ButtonFlatMedium>
      </Box>
      { !showMagicLinkSuccess 
      ? <Login
        pageTitle='Log in to continue'
        />
      : <Box className={cx(styles.magicLinkContent)}>
          <MagicLinkSuccess
            email={ loginEmail?.toString() || '' }
            resendMagicLinkHandler={ resendLink }
            updateEmailHandler={ updateEmail }
          />
        </Box>

      }
    </SwipeableDrawer>
  );
};

